module.exports = __webpack_public_path__ + "static/media/1005264.91fdae6d.jpg";